import {postData,getData,deleteData} from './request'

// 最近列表
export function loadrecent({count,offset}, cb) {
  return getData(`/api/v4/roam?count=${count}&offset=${offset}`, {}, cb)
}

// 删除操作记录
export function doDeleteRecord(paload, cb) {
  // return deleteData(`/api/v3/recentinfo/batch/destory`, paload, {}, cb)
  return postData(`/api/v3/roaming/batch/destory `, paload, {}, cb)
}

// 加载漫游记录
export function loadroaming({count,offset}, cb) {
  return getData(`/api/v3/roaming?count=${count}&offset=${offset}&max_mtime=${new Date().getTime()}`, {}, cb)
}
// 获取文档占用空间
export function getSpace(cb) {
  return getData(`/api/v3/spaces`, {}, cb)
}
// 获取事件列表(包括团队事件)
export function getEvents({count,offset,type,groupid},cb) {
  let url = groupid ? `/api/v3/groups/${groupid}/events?count=${count}&offset=${offset}` : `/api/v3/events?count=${count}&offset=${offset}`
  return getData(url, {}, cb)
}

// 批量获取星标文件
export function loadstars(paload,cb) {
  return postData(`/api/v3/tags/files`,paload, {}, cb)
}


// WEBPACK FOOTER //
// ./src/store/service/latest.js